<template>
  <div style="background-color:white">
    <h1 align="left">检定详情</h1>
    <el-form ref="form" :model="form" label-width="100px">
      <el-row>
        <div style="float: right; margin-right: 400px">
          <el-col :span="10">
            <el-form-item>
              <el-button type="primary" v-if="show.xg" @click="handleCreate1"> 修改</el-button>
            </el-form-item></el-col>
          <el-col :span="10">
            <el-form-item>
              <el-button type="primary" v-if="isShow & show.zf" @click="deleteCheck">作废</el-button>
            </el-form-item>
          </el-col>
        </div>

      </el-row>
      <el-row :gutter="20">
        <el-col :span="9" :push="1">
          <el-form-item :label="lable.id">
            <el-input v-model="form.id" :readonly="true"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6"></el-col>
        <el-col :span="8" :push="3"><el-form-item label="创建日期">
            <el-input v-model="form.checkEnterTime" :readonly="true"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="9" :push="1">
          <el-form-item :label="lable.jdsb">
            <el-input v-model="form.jdsb" :readonly="true"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
        </el-col>
        <el-col :span="8" :push="3"><el-form-item label="规格型号">
            <el-input v-model="form.sbxh" :readonly="true"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="9" :push="1">
          <el-form-item label="生产厂家">
            <el-input v-model="form.sccj" :readonly="true"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="2" :push="1"> </el-col>
        <el-col :span="6"></el-col>
        <el-col :span="8" :push="3"><el-form-item label="出厂编号">
            <el-input v-model="form.ccbh" :readonly="true"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="9" :push="1">
          <el-form-item label="管理编号">
            <el-input v-model="form.glbh" :readonly="true"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="9" :push="1">
          <el-form-item label="检定单位">
            <el-input v-model="form.checkCompany" :readonly="true"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="2" :push="1"> </el-col>
        <el-col :span="6"></el-col>
        <el-col :span="8" :push="3">
          <el-form-item :label="lable.checkCertificate">
            <el-input v-model="form.checkCertificate" :readonly="true"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="9" :push="1">
          <el-form-item :label="lable.checkTime">
            <el-date-picker :readonly="true" v-model="form.checkTime" value-format="yyyy-MM-dd" type="date"
              style="width:100%">
            </el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="2" :push="1">
        </el-col>
        <el-col :span="6"></el-col>
        <el-col :span="8" :push="3">
          <el-form-item :label="lable.jg">
            <el-input v-model="form.jg" :readonly="true"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="9" :push="1">
          <el-form-item label="检定备注">
            <el-input v-model="form.remarks" :readonly="true" type="textarea"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="19" :push="1">
          <el-form-item label="附件列表" align="left">
            <el-table :header-cell-style="{ textAlign: 'center', background: '#eff3f6' }"
              :cell-style="{ textAlign: 'center' }" ref="multipleTable" :data="fileData" tooltip-effect="dark"
              style="width: 100%" height="290">
              <el-table-column label="附件序号" type="index" width="100">
              </el-table-column>
              <el-table-column prop="createTime" label="时间" width="200">
              </el-table-column>
              <el-table-column prop="enclosureName" label="文件名称" show-overflow-tooltip>
              </el-table-column>
              <el-table-column prop="fileDescribe" label="资料备注" show-overflow-tooltip>
              </el-table-column>
              <el-table-column label="操作" show-overflow-tooltip>
                <template slot="header" slot-scope="scope">
                  <el-button class="flter-item" type="primary" @click="handleCreate">添加</el-button>
                </template>
                <template slot-scope="scope">
                  <el-button @click="yulan(scope.row)" type="text" size="small">在线预览</el-button>
                  <!-- <preview></preview> -->
                  <el-button @click="downloading(scope.row)" type="text" size="small">下载</el-button>
                  <el-button @click="updateFile(scope.row)" type="text" size="small">修改</el-button>

                  <el-button @click="DFile(scope.row)" type="text" size="small">删除</el-button>

                </template>
              </el-table-column>
            </el-table>
          </el-form-item>
          <el-row :gutter="20">
            <el-col :span="2" :push="9">
              <el-form-item>
                <el-button type="success" @click="revert">返回</el-button>
              </el-form-item>
            </el-col>
          </el-row>
        </el-col>
      </el-row>
    </el-form>

    <!---------------------------------------------------附件资料上传弹框 ---------------------------------------------------------->
    <el-dialog :visible.sync="dialogFormVisible" :close-on-click-modal="false" :close-on-press-escape="false"
      :append-to-body="true" title="附件资料上传" style="width:60% !important;margin-left: 300px;">
      <el-form ref="form" :model="formTwo" label-width="80px" style="width: 80%; margin-left:30px;">
        <el-form-item label="文件名称">
          <el-select v-model="formTwo.fileName" placeholder="请选择" style="width:100%">
            <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="资料备注">
          <el-input type="textarea" v-model="formTwo.fileDesc"></el-input>
        </el-form-item>
        <el-form-item label="文件上传">
          <el-upload class="upload" ref="upload" action="string" :file-list="fileList" :auto-upload="false"
            accept=".jpg,.npg,.png,.doc,.docx,.pdf,.xlsx" :http-request="uploadFile" :on-change="handleChange"
            :on-preview="handlePreview" :on-remove="handleRemove" multiple="multiple">
            <el-button slot="trigger" size="small" type="primary" @click="delFile">选取文件</el-button>
          </el-upload>
          <span>上传文件只能是jpg,png,npg,doc,docx,pdf,xlsx格式</span>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="onSubmit" v-preventReClick>上传</el-button>
          <el-button @click="cancelSubmit">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>

    <!---------------------------------------------------检定修改弹框 ---------------------------------------------------------->
    <el-dialog :visible.sync="dialogFormVisible1" title="检定信息修改" :close-on-click-modal="false"
      :close-on-press-escape="false" :append-to-body="true" style="width:50% !important;margin-left: 400px;">
      <el-form ref="form" :model="form" label-width="100px" style="width: 80%; margin-left:40px;">
        <el-form-item label="检定单位">
          <el-input v-model="form.checkCompany"></el-input>
        </el-form-item>
        <el-form-item :label="lable.checkCertificate">
          <el-input v-model="form.checkCertificate"></el-input>
        </el-form-item>
        <el-form-item :label="lable.checkTime">
          <el-date-picker :disabled="!isShow" v-model="form.checkTime" value-format="yyyy-MM-dd" style="width:100%"
            type="date" placeholder="选择日期">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="检定备注">
          <el-input type="textarea" v-model="form.remarks"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="update" v-preventReClick>确认</el-button>
          <el-button @click="cancelSubmit1">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <!---------------------------------------------------附件资料修改 ---------------------------------------------------------->
    <el-dialog :visible.sync="dialogFormVisible" :close-on-click-modal="false" :close-on-press-escape="false"
      :append-to-body="true" title="附件资料上传" style="width: 60% !important;margin-left:350px;">
      <el-form ref="formTwo" :model="formTwo" label-width="80px" style="width: 80%; margin-left:30px;">
        <el-form-item label="文件名称" prop="fileName">
          <el-select v-model="formTwo.fileName" placeholder="请选择" style="width:100%">
            <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="资料备注" prop="fileDesc">
          <el-input type="textarea" v-model="formTwo.fileDesc"></el-input>
        </el-form-item>
        <el-form-item label="id" prop="id" v-if="false">
          <el-input type="textarea" v-model="formTwo.id"></el-input>
        </el-form-item>
        <el-form-item label="文件上传">
          <el-upload class="upload" ref="upload" action="string" :file-list="fileList" :auto-upload="false"
            accept=".jpg,.npg,.png,.doc,.docx,.pdf,.xlsx" :http-request="uploadFile" :on-change="handleChange"
            :on-preview="handlePreview" :on-remove="handleRemove" multiple="multiple">
            <el-button slot="trigger" size="small" type="primary" @click="delFile">选取文件</el-button>
          </el-upload>
          <span>上传文件只能是jpg,png,npg,doc,docx,pdf格式</span>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" @click="onSubmit" v-preventReClick>上传</el-button>
          <el-button @click="cancelSubmit">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog :visible.sync="updateDialog" :close-on-click-modal="false" :close-on-press-escape="false"
      :append-to-body="true" title="附件资料修改" style="width: 60% !important;margin-left:350px;">
      <el-form ref="formTwo" :model="fileForm" label-width="80px" style="width: 80%; margin-left:30px;">
        <el-form-item label="文件名称" prop="enclosureName">
          <el-select v-model="fileForm.enclosureName" placeholder="请选择" style="width:100%">
            <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="资料备注" prop="fileDescribe">
          <el-input type="textarea" v-model="fileForm.fileDescribe"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="clickUpdate" v-preventReClick>修改</el-button>
          <el-button @click="cancelSubmit">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog :title="previewTitle" :visible.sync="docxdialog" style="margin-top:-50px" width="63%">
      <FilePreview ref="filePreview" />
    </el-dialog>
    <div>
    </div>
  </div>
</template>

<script>
import {
  selectByIdCheck,
  updateDeviceCheck,
  uploadFlie,
  findByidFile,
  delCheckFile,
  delByIdCheck,
  findByModule,
  updateCheckEnclosure

} from "../../api/api";
import FilePreview from '../../components/preview/FilePreview.vue'

export default {
  name: "Particulars",
  components: {
    "FilePreview": FilePreview,
  },
  data() {
    return {
      lable: {},
      form: {
        id: "",
        jdsb: "",
        sbxh: "",
        sccj: "",
        ccbh: "",
        checkCompany: "",
        checkCertificate: "",
        checkTime: "",
        checkEnterTime: "",
        remarks: "",
        ssdw: "",
        glbh: "",
        remarks: "",
        deviceId: ""
      },
      updateDialog: false,
      fileForm: {},
      formTwo: {
        fileName: "",
        fileDesc: "",
        id: ""
      },
      options: [{
        value: "检定证书",
        label: "检定证书"
      }, {
        value: "设备图片",
        lable: "设备图片"
      }, {
        value: "确认表",
        lable: "确认表"
      }
      ],
      isShow: false,
      docxdialog: false,
      previewTitle: '',
      dialogFormVisible: false,
      dialogFormVisible1: false,
      fileData: [],
      fileList: [],
      // 不支持多选
      multiple: false,
      formData: "",
      show: {
        xg: false,
        zf: false,
      }
    };
  },

  methods: {
    updateFile(row) {
      // console.log(row)
      this.fileForm = _.cloneDeep(row);
      this.updateDialog = true
    },
    clickUpdate(row) {
      var parmar = {
        id: this.fileForm.id,
        enclosureName: this.fileForm.enclosureName,
        describe: this.fileForm.fileDescribe
      }
      updateCheckEnclosure(parmar).then(datas => {
        let { data, message, status } = datas
        if (status == 200) {
          this.cancelSubmit();
          this.selectFile(this.form.id);
          this.$message.success(message)
        } else {
          this.$message.error(message)
        }
      })
    },
    yulan(row) {

      if (row.path.substring(row.path.lastIndexOf(".") + 1) == 'jpg' || row.path.substring(row.path.lastIndexOf(".") + 1) == 'png' || row.path.substring(row.path.lastIndexOf(".") + 1) == 'jpeg') {
        this.previewTitle = "图片预览"
      } else {
        this.previewTitle = "文件预览"
      }
      this.docxdialog = true
      this.$nextTick(() => {
        this.$refs.filePreview.showView(row.path)
      })
    },

    downloading(scop) {
      // debugger
      this.downloadUtil.downloadFile(scop.path, scop.enclosureName);
    },
    update() {
      var userinfo = JSON.parse(localStorage.getItem("user"))
      this.form.userId = userinfo.userId
      updateDeviceCheck(this.form).then(datas => {
        let { status, message } = datas;
        if (status == 400) {
          this.$message({
            message: message,
            type: "error"
          });
        } else if (status == 200) {
          this.dialogFormVisible1 = false;
          this.$message({
            message: "修改成功",
            type: "success"
          });
        } else {
          this.$message({
            message: "请求错误",
            type: "error"
          });
        }
      });
    },
    cancelSubmit() {
      this.dialogFormVisible = false;
      this.updateDialog=false;
    },
    cancelSubmit1() {
      this.dialogFormVisible1 = false;
    },
    handleCreate1() {
      this.dialogFormVisible1 = true;
    },
    handleCreate() {
      this.dialogFormVisible = true;
    },
    //根据id查找附件
    selectFile(row) {
      findByidFile(row).then(datas => {
        // debugger
        let { status, message, data } = datas;
        if (status == 200) {
          this.fileData = data;
        }
      });
    },
    //删除检定附件信息
    DFile(row) {
      this.$confirm('此操作将永久删除该信息, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        delCheckFile(row.id).then(datas => {
          let { status, message } = datas;
          if (status == 400) {
            this.$message({
              message: message,
              type: "error"
            });
          } else if (status == 200) {
            this.selectFile(this.form.id);
            this.$message({
              message: "删除成功",
              type: "success"
            });
          } else {
            this.$message({
              message: "请求错误",
              type: "error"
            });
          }
        })
      })
    },

    revert() {
      this.$router.push({
        path: "verification"
      });
    },
    //作废
    deleteCheck() {
      this.$confirm("确定作废该条信息, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          var userinfo = JSON.parse(localStorage.getItem("user"))
          var map = {
            id: this.form.id,
            userId: userinfo.userId
          }
          delByIdCheck(map).then(datas => {
            let { status, message } = datas;
            if (status == 400) {
              this.$message({
                message: message,
                type: "error"
              });
            } else if (status == 200) {
              this.$message({
                message: "作废成功",
                type: "success"
              });
              this.$router.push({
                path: "verification"
              });
            } else {
              this.$message({
                message: "请求错误",
                type: "error"
              });
            }
          });
        })
    },
    //根据id查找信息
    selectById(row) {
      selectByIdCheck(row).then(datas => {
        let { status, message, data } = datas;
        if (status == 200) {
          this.form = data;
          if (this.form.checkStatue == 1) {
            this.isShow = true;
          }
        }
      });
    },

    //文件上传
    onSubmit() {
      if (this.fileList[0] == null) {
        this.$message.error("请选择上传的文件"); // .....失败信息
      } else {
        let formData = new FormData();
        formData.append("file", this.fileList[0].raw); //拿到存在fileList的文件存放到formData中
        //下面数据是我自己设置的数据,可自行添加数据到formData(使用键值对方式存储)
        formData.append("checkId", this.form.id);
        formData.append("enclosureName", this.formTwo.fileName);
        formData.append("describe", this.formTwo.fileDesc);
        var userinfo = JSON.parse(localStorage.getItem("user"))
        formData.append("userId", userinfo.userId);
        uploadFlie(formData).then(datas => {
          let { status, message } = datas;
          if (status == 400) {
            this.$message({
              message: message,
              type: "error"
            });
          } else if (status == 200) {
            this.selectFile(this.form.id);
            this.$message({
              message: "上传成功",
              type: "success"
            });
          } else {
            this.$message({
              message: "请求错误",
              type: "error"
            });
          }
          this.formTwo.fileDesc = "";
          this.formTwo.fileName = "";
          this.fileList = [];
          this.dialogFormVisible = false;
        });
      }
    },

    //点击上传文件触发的额外事件,清空fileList
    delFile() {
      this.fileList = [];
    },
    handleChange(file, fileList) {
      this.fileList = fileList;
    },
    //自定义上传文件
    uploadFile(file) {
      this.formData.append("file", file.file);
    },
    //删除文件
    handleRemove(file, fileList) {
    },
    // 点击文件
    handlePreview(file) {
    },
    findLable() {
      findByModule("设备检定").then(datas => {
        let { status, message, data } = datas;
        if (status == 200) {
          this.lable = data;
        }
      });
    },
  },

  created() {
    this.findLable();
    var id = sessionStorage.getItem("id");
    this.selectById(id);
    this.selectFile(id);
    var userinfo = JSON.parse(localStorage.getItem("user"))
    var arr = userinfo.role.menuId.split(",");
    arr.forEach((i) => {
      if (i == "90") {
        this.show.xg = true;
      }
      if (i == "91") {
        this.show.zf = true;
      }
    })
  }
};
</script>
<style >
.el-checkbox__inner {
  border: 1px solid #606266 !important;
}
</style>
<style scoped></style>



// WEBPACK FOOTER //
// src/views/verification/Particulars.vue